import { render, staticRenderFns } from "./MailContactTypeList.vue?vue&type=template&id=6a3ef2b2&"
import script from "./MailContactTypeList.vue?vue&type=script&lang=js&"
export * from "./MailContactTypeList.vue?vue&type=script&lang=js&"
import style0 from "./MailContactTypeList.vue?vue&type=style&index=0&id=6a3ef2b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports